jQuery( document ).ready( function( $ ) {


    /**
     * Init emergence library
     */ 
    emergence.init({
      reset: false,
      elemCusion: .95,
    });


    /**
     * Add class to navbar-toggler when clicked
     */
    $('.navbar-toggler').click(function() {
        $(this).toggleClass('open');
        $('.main-navigation').toggleClass('closed');
        $('.main-navigation').toggleClass('open');
        $('body').toggleClass('locked');

        $(this).parent().toggleClass('clicked');
    });


    /**
     * Add a span to main menu text
     */
    $("a.nav-link:contains('Foss Recycling')").html(function(_, html) {
       return html.replace(/(Foss Recycling)/g, '<span>Foss Recycling</span>');
    });


    /**
     * Set cookie for site notification dismissal
     */
    if ($.cookie('site_note_close') != 'true') {
      $('.site-notification').removeClass('d-none');

      $('.site-note-close').click(function() {
        $.cookie('site_note_close', 'true', { expires: 10, path: '/' }); 
      });
    } else if ($.cookie('site_note_close') === 'true') {        
    };     
  

    /**
     * Home Slick Slider
     */
    $('.home-slider').on('init breakpoint', function(event, slick, direction){      
      setTimeout(function() {
        $('.slick-active .slide-item .color-screen').addClass('active');  
      }, 250);     
      setTimeout(function() {
        $('.slick-active .slide-item .slide-small-title').addClass('active');
      }, 550);
      setTimeout(function() {
        $('.slick-active .slide-item .slide-large-title').addClass('active');
      }, 650);
      setTimeout(function() {
        $('.slick-active .slide-item .slide-item--content').addClass('active');
      }, 750);                  
    });    
    $('.home-slider.slick-slideshow').slick({
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 8000,
      pauseOnHover: false,
      pauseOnFocus: false
    });
    $('.home-slider').on('afterChange', function(event, slick, currentSlide){
      setTimeout(function() {
        $('.slick-active .slide-item .color-screen').addClass('active');  
      }, 250);     
      setTimeout(function() {
        $('.slick-active .slide-item .slide-small-title').addClass('active');
      }, 550);
      setTimeout(function() {
        $('.slick-active .slide-item .slide-large-title').addClass('active');
      }, 650);
      setTimeout(function() {
        $('.slick-active .slide-item .slide-item--content').addClass('active');
      }, 750);      
    });
    $('.home-slider').on('beforeChange', function(event, slick, nextSlide){
      $('.slide-item .color-screen').removeClass('active');    
      $('.slide-item .slide-small-title').removeClass('active');
      $('.slide-item .slide-large-title').removeClass('active');
      $('.slide-item .slide-item--content').removeClass('active');  
    });    


    /**
     * Testimonials Slick Slider
     */
    $('.testimonial-slider.slick-slideshow').slick({
      dots: true,
      arrows: false,
      autoplay: false,
      //autoplaySpeed: 6000,
      //pauseOnHover: false,
      //pauseOnFocus: false
    });


    /**
     * Interior page header animations on load
     */
    if ( $('.page-header__title').length ) {
      setTimeout(function() {
        $('.page-header__title').addClass('active'); 
      }, 150);     
    }
    if ( $('.page-header__content').length ) {
      setTimeout(function() {
        $('.page-header__content').addClass('active');
      }, 550);     
    }    


    /**
     * Match Height declarations
     */
    $('.team-info-container header').matchHeight({byRow: false,});
    

    /**
     * Portfolio tab click (change icon)
     */ 
    var $tabIcons = $('.portfolio-tabs .nav-link i');
    $('.portfolio-tabs .nav-link').click(function() {
      //remove - from all icons, add +.
      $tabIcons.removeClass('fa-minus').addClass('fa-plus');

      //remove + from this tab icon, add -.
      $(this).find('i').removeClass('fa-plus').addClass('fa-minus');
    });    

    // toggle data-emergence animation on
    $('button[data-bs-toggle="tab"]').on('shown.bs.tab', function(event){
      var showTarget = $(event.target).data('bs-target') // activated tab
      var newShowTarget = showTarget.replace('#', '');
      //console.log('#' + newTarget + ' div div .de-left-in');
      $('#' + newShowTarget + ' .de-left-in').attr('data-emergence', 'visible');
      $('#' + newShowTarget + ' .de-right-in').attr('data-emergence', 'visible');
      $('#' + newShowTarget + ' .de-fade').attr('data-emergence', 'visible');
    });

    // toggle data-emergence animation off
    $('button[data-bs-toggle="tab"]').on('hidden.bs.tab', function(event){
      var hideTarget = $(event.target).data('bs-target') // activated tab
      var newHideTarget = hideTarget.replace('#', '');
      //console.log('#' + newHideTarget + ' div div .de-left-in');
      $('#' + newHideTarget + ' .de-left-in').attr('data-emergence', 'hidden');
      $('#' + newHideTarget + ' .de-right-in').attr('data-emergence', 'hidden');
      $('#' + newHideTarget + ' .de-fade').attr('data-emergence', 'hidden');
    });        


    /**
     * Update pagination next/prev classes
     *
     */
    $(".index-pagination .next").addClass("plus-link dark");
    $(".index-pagination .prev").addClass("plus-link dark");


    /**
     * Smooth Scroll Hashed Links
     * This will scroll to link on same page
     * Or will smoothly scroll to a hashed section on another page after click
     */
    $(function() {
      // your current click function
      // select all links with hashes, remove if don't link to anything (:not)
      // this is for same page hashed links
      $('a[href*=\\#]:not([href=\\#])').on('click', function() {
          if (!$(this).parents('ul').hasClass('nav-tabs')) {
              var target = $(this.hash);
              // if target.length is 0, set target equal to the name attribuite with hash as value
              target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
              // smooth scroll to the target id
              if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top
                }, 1000);
                return false;
              }
          }
      });

      // check if the window location (URL) has a hash in it
      // smoothly scroll to that location
      if(window.location.hash) {
          var target = $(window.location.hash);
          // if target.length is 0, set target equal to the name attribuite with hash as value
          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
          // smooth scroll to the target id
          $('html, body').delay(1000).animate({
            scrollTop: $(target).offset().top + 'px'
          }, 1000);
          return false;
      }

    });


    /**
     * Reveal job application form section when button is clicked
     */
    $('.career-form-reveal').click(function() {
        $('.career-form-container').toggleClass('d-none');
    });
} );
